import React, { useRef, Fragment } from 'react'
import { Carousel, Divider, Card, Typography, Button, Row, Col } from 'antd';
import { TwitterOutlined } from '@ant-design/icons';
import {InnerTweets} from './Tweets';
import Trends from './charts/Trends'
import WordCloud from './charts/WordCloud'
import '../App.css'


const { Title } = Typography;

const TwitterStatistics = (props) => {
    const { screenName, tweets, wordData, trends } = props
    const tweetsListRef = useRef()

    const setTweetsList = (title, tweets) => { 
        tweetsListRef.current.setData(title, tweets)
    }

    return (
        tweets && tweets.length > 0 ?
            <Fragment>
                <Divider orientation="left" style={{ "display": tweets && tweets.length > 0 ? '' : 'none' }}><Title align="left" level={5} style={{ color: 'white' }}><a href={"https://twitter.com/" + tweets[0].screenName} target="blank">{tweets[0].userName}</a> 的最新推文：</Title></Divider>
                <Row gutter={24}>
                    <Col span={9} offset={0}>
                        <Carousel autoplay>
                            {
                                tweets.map(
                                    (tweet) => {
                                        return (
                                            <Card size="small" align='left' title={<Title align="left" level={5}><Button type="text" icon={<TwitterOutlined frameBorder={false} />} /><a href={"https://twitter.com/" + tweet.screenName} target="blank">{"@" + tweet.screenName}</a>&nbsp; &nbsp; {tweet.created_at}</Title>}>
                                                <p align="left"><b style={{ "display": tweet.transText === "" ? 'none' : '' }}>原文：</b>{tweet.text}</p>
                                                <p align="left" style={{ "display": tweet.transText === "" ? 'none' : '' }}><b>译文：</b>{tweet.transText}</p>
                                            </Card>
                                        )
                                    }
                                )
                            }
                        </Carousel>
                    </Col>
                    <Col span={7}>
                        <WordCloud screenName={screenName} setTweetsList={setTweetsList} wordData={wordData}/>
                    </Col>
                    <Col span={7} >
                        <Trends screenName={screenName} setTweetsList={setTweetsList} trendsData={trends}/>
                    </Col>
                </Row>
                <InnerTweets ref={tweetsListRef}/>
            </Fragment>
            : ''
    )
}

export default TwitterStatistics;
